var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color)?_c('div',{staticClass:"eg-colored-dot-box",style:({
    '--color-box-color': _vm.color,
    '--color-box-background-color': _vm.backgroundColor,
  })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }